import { useEffect, useState } from "react";
import "./runAnalysis.css";
import { useNavigate, useParams } from "react-router-dom";
import { toast } from "react-toastify";
import { useLocation } from "react-router-dom";
import axios from "axios";



const RunAnalysis = () => {
  // const { id } = useParams();
  const location = useLocation();
  const { id, reportId, start_date, end_date } = location.state || {};
  const navigate = useNavigate();
  const [algorithm, setAlgorithm] = useState("apriori");
  const [analysisTitle,setAnalysisTitle] = useState("")
  const [analysisNotes,setAnalysisNotes] = useState("")
  const [minSupport, setMinSupport] = useState(0.01);
  const [itemset, setItemset] = useState("all");
  const [isExcludeSingleOrder, setIsExcludeSingleOrder] = useState(true);
  const [isExcludeCancelOrder, setIsExcludeCancelOrder] = useState(false);
  const [loading, setLoading] = useState(false);
  const [timerActive, setTimerActive] = useState(false);
  const [elapsedSeconds, setElapsedSeconds] = useState(0);
  const [error, setError] = useState("");
  const [errorNotes, setErrorNotes] = useState("");

  const [navigateData, setNavigateData] = useState({
    id: id,
    reportId: reportId,
    start_date: start_date,
    end_date: end_date
  })
  

  const handleRunAnalysis = async () => {
    if (!algorithm || !minSupport || !itemset) {
      toast.error("Please fill all required fields.", {
        position: "top-right",
        autoClose: 3000,
      });
      return;
    }

    if (!analysisTitle.trim()) {
      setError("Analysis title is required.");
      setTimeout(()=>{
        setError("")
      },3000)
      return;
    }

    if (!analysisNotes.trim()) {
      setErrorNotes("Analysis notes is required.");
      setTimeout(()=>{
        setErrorNotes("")
      },3000)
      return;
    }

    let scope = {
      "isSingle": itemset == 1,
      "isPairs": itemset == 2,
      "isTriples": itemset == 3,
      "isQuadruples": itemset == 4,
      "isAll": itemset === 'all'
    };

    const payload = {
      algorithm,
      min_support: (minSupport / 100),
      isExcludeSingleOrder,
      isExcludeCancelOrder,
      analysis_scope: scope,
      order_details_id: id,
      analysis_title: analysisTitle,
      analysis_notes: analysisNotes
    };

    try {
      setLoading(true);
      setElapsedSeconds(0);
      setTimerActive(true);

      const controller = new AbortController();
      const timeoutId = setTimeout(() => controller.abort(), 25 * 60 * 1000); // 25 mins

      const response = await fetch(`${process.env.REACT_APP_DATA_ANALYSIS}`, {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
          Authorization: `Bearer ${localStorage.getItem('token')}`,
        },
        body: JSON.stringify(payload),
        signal: controller.signal,
      });

      clearTimeout(timeoutId);

      if (!response.ok) {
        const errorResult = await response.json();
        if (errorResult?.detail?.isExpireToken) {
          const token = localStorage.removeItem("token");
          const user = localStorage.removeItem("userInfo");
          navigate("/login")
        }
        throw new Error(errorResult.message || 'Failed to run analysis');
      }

      const result = await response.json();

      navigate(`/history-analysis/${result.analysis_details_id}`);
      navigate("/history-analysis", {
        state: { order_details_id: navigateData.id ,id: result.analysis_details_id, start_date: navigateData.start_date, end_date: navigateData.end_date }
      })

    } catch (err) {
      if (err.name === 'AbortError') {
        toast.error("Request timed out after 25 minutes.", {
          position: "top-right",
          autoClose: 3000,
        });
      } else {
        toast.error(err.message || err, {
          position: "top-right",
          autoClose: 3000,
        });
      }
    } finally {
      setTimerActive(false);
      setLoading(false);
    }
  };


  useEffect(() => {
    let timer;
    if (timerActive) {
      timer = setInterval(() => {
        setElapsedSeconds((prev) => prev + 1);
      }, 1000);
    }

    return () => clearInterval(timer);
  }, [timerActive]);

  return (
    <main className=" mx-auto px-4 py-6 sm:px-6 lg:px-8">
      <div className="py-4   flex justify-between items-center">
        <div>
          <h2 className="text-2xl font-bold text-gray-900">Run New Analysis: <span class="text-2xl font-bold  text-gray-500">Order Report {navigateData.reportId}</span></h2>
        </div>


        <div className="flex space-x-2">
          <button
            className="bg-gray-200 text-gray-800 px-4 py-2 rounded-lg text-sm hover:bg-gray-300 transition duration-300"
            onClick={() => navigate(- 1)}
          >
            ← Back
          </button>
        </div>

      </div>
      <div class="flex items-center mt-2">
        <span class="text-sm text-gray-500"><i class="fas fa-calendar-alt mr-1"></i> Orders from <b>{navigateData.start_date}</b> to <b>{navigateData.end_date}</b></span>
      </div>
      <div className="container mx-auto py-8">
        <div className="flex flex-col lg:flex-row gap-6">
          <div className="lg:w-1/3">
            <div className="config-card p-6 mb-6" id="disableAfterRun">
            <div className="mb-5">
              <div className="flex justify-between items-center mb-1">
                <h3 className="text-sm font-semibold text-gray-600 uppercase tracking-wider mb-3">
                  Analysis Title *
                </h3>
              </div>
              <div className="flex justify-between items-center mb-1">
                <input
                  maxLength={100}
                  value={analysisTitle}
                  onChange={(e) => setAnalysisTitle(e.target.value)}
                  className={`w-full px-4 py-2 border ${
                    error ? "border-red-500" : "border-gray-300"
                  } rounded-lg focus:outline-none focus:ring-2 focus:ring-indigo-500`}
                  type="text"
                  placeholder="Enter Analysis Report Name"
                />
              </div>
              {error && <p className="text-red-500 text-sm mt-1">{error}</p>}
            </div>

              <div className="mb-5">
                <div className="flex justify-between items-center mb-1">
                  <h3 className="text-sm font-semibold text-gray-600 uppercase tracking-wider mb-3">Note</h3>
                </div>
                <div className="flex justify-between items-center mb-1">
                  <textarea class={`w-full px-3 py-2 border ${
                    errorNotes ? "border-red-500" : "border-gray-300"
                  } rounded-md text-sm focus:outline-none focus:ring-1 focus:ring-indigo-500`} placeholder="Add a note about this analysis..." value={analysisNotes} onChange={(e)=>setAnalysisNotes(e.target.value)}></textarea>
                </div>
                {errorNotes && <p className="text-red-500 text-sm mt-1">{errorNotes}</p>}
              </div>


              {/* Algorithm */}
              <div className="mb-8">
                <h3 className="text-sm font-semibold text-gray-600 uppercase tracking-wider mb-3">Choose Algorithm *</h3>
                <div className="grid grid-cols-2 gap-2">
                  {["apriori", "fpgrowth"].map(a => (
                    <button
                      key={a}
                      className={`algorithm-tab py-3 px-4 rounded-lg border border-gray-200 ${algorithm === a ? 'bg-indigo-100 border-indigo-600' : ''}`}
                      onClick={() => setAlgorithm(a)}
                    >
                      {a === "apriori" ? <i className="fas fa-sitemap mr-2"></i> : <i className="fas fa-project-diagram mr-2"></i>}
                      {a.charAt(0).toUpperCase() + a.slice(1)}
                    </button>
                  ))}
                </div>
                <p className="text-xs text-gray-500 mt-2">Apriori is better for smaller datasets, FP-Growth for larger ones</p>
              </div>

              {/* Itemset Size */}
              <div className="mb-8">
                <h3 className="text-sm font-semibold text-gray-600 uppercase tracking-wider mb-3">Itemset Size *</h3>
                <select
                  className="w-full px-4 py-3 border border-gray-200 rounded-lg"
                  value={itemset}
                  onChange={(e) => setItemset(e.target.value)}
                >
                  <option value="1">Single Items (1)</option>
                  <option value="2">Pairs (2)</option>
                  <option value="3">Triplets (3)</option>
                  <option value="4">Quadruplets (4)</option>
                  <option value="all">All Combinations</option>
                </select>
              </div>

              {/* Support */}
              <div className="mb-5">
                <div className="flex justify-between items-center mb-1">
                  <h3 className="text-sm font-semibold text-gray-600 uppercase tracking-wider mb-3">Minimum Support *</h3>
                  <span className="text-sm font-medium bg-indigo-100 text-indigo-800 px-2 py-1 rounded-full">{minSupport}%</span>
                </div>
                <input
                  type="number"
                  // min="1"
                  max="100"
                  value={minSupport}
                  onChange={(e) => {
                    const value = e.target.value;
                    setMinSupport(value);
                  }}
                  className="w-full px-4 py-2 border border-gray-300 rounded-lg focus:outline-none focus:ring-2 focus:ring-indigo-500"
                />
              </div>

              {/* Exclude Single Orders */}
              <div className="mb-6">
                <h3 className="text-sm font-semibold text-gray-600 uppercase tracking-wider mb-3">Advanced Filters</h3>
                <label className="flex items-center space-x-3 cursor-pointer">
                  <input
                    type="checkbox"
                    checked={isExcludeSingleOrder}
                    onChange={(e) => setIsExcludeSingleOrder(e.target.checked)}
                    className="form-checkbox h-5 w-5 text-indigo-600 rounded"
                  />
                  <span className="text-gray-700">Exclude Single Orders</span>
                </label>
              </div>

              <div className="mb-6">
                <label className="flex items-center space-x-3 cursor-pointer">
                  <input
                    type="checkbox"
                    checked={isExcludeCancelOrder}
                    onChange={(e) => setIsExcludeCancelOrder(e.target.checked)}
                    className="form-checkbox h-5 w-5 text-indigo-600 rounded"
                  />
                  <span className="text-gray-700">Exclude Cancel Orders</span>
                </label>
              </div>

              <button
                onClick={handleRunAnalysis}
                className="w-full bg-indigo-600 hover:bg-indigo-700 text-white font-medium py-3 px-4 rounded-lg transition duration-300 flex items-center justify-center"
                disabled={loading}
              >
                <i className="fas fa-play-circle mr-2"></i> {loading ? 'Running...' : 'Save & Run Analysis'}
              </button>
            </div>
          </div>

          {/* Right Panel - Placeholder */}
          <div className="lg:w-2/3">
            <div id="resultsPlaceholder" className="config-card p-12 text-center">
              <div className="max-w-md mx-auto">
                <div className="bg-indigo-100 rounded-full w-16 h-16 flex items-center justify-center mx-auto mb-4">
                  <i className="fas fa-sliders-h text-indigo-600 text-2xl"></i>
                </div>
                <h3 className="text-xl font-semibold text-gray-800 mb-2">Adjust the settings & Configure Your Analysis</h3>
                <button
                  disabled={loading}
                  onClick={handleRunAnalysis}
                  className="bg-indigo-600 hover:bg-indigo-700 text-white font-medium py-2 px-6 rounded-lg transition duration-300 inline-flex items-center"
                >
                  <i className="fas fa-play mr-2"></i> {loading ? "Please wait..." : "Save & Run Analysis"}

                </button>
                <p class="text-gray-600 mb-6">This may take a few minutes depending on your order volume ({Math.floor(elapsedSeconds / 60)}m {elapsedSeconds % 60}s)</p>
              </div>
            </div>
          </div>
        </div>
      </div>
    </main>
  );
};

export default RunAnalysis;
